
export default { name: 'House2' };
